import * as React from 'react';
import { StyleSheet, Platform } from 'react-native';
import { translate } from 'secullum-i18n';
import { isTablet, Card, Text } from 'secullum-react-native-ui';
import {
  getLarguraCampoData,
  getTamanhoFonte
} from '../containers/InconsistenciasContainer';
import { getTheme, isHighResolution } from '../modules/layout';

class InconsistenciaHeader extends React.Component {
  render() {
    const tamanhoFonte = getTamanhoFonte();
    const larguraCampoData = getLarguraCampoData();
    const webDesktop = Platform.OS === 'web' && isHighResolution();

    return (
      <Card.Section style={styles.headerContainer}>
        <Text
          bold
          flex={webDesktop ? 2 : undefined}
          size={tamanhoFonte}
          color={theme.textColor3}
          style={[styles.headerText, { width: larguraCampoData }]}
          nativeID="inconsistencia-header-data"
        >
          {translate('Data')}
        </Text>
        <Text
          bold
          flex={2}
          size={tamanhoFonte}
          color={theme.textColor3}
          style={styles.headerText}
          nativeID="inconsistencia-header-tipo"
        >
          {translate('Tipo')}
        </Text>
        <Text
          bold
          flex={1.5}
          size={tamanhoFonte}
          color={theme.textColor3}
          style={[
            styles.headerText,
            { width: Platform.OS === 'web' ? 65 : isTablet() ? 70 : 40 }
          ]}
          nativeID="inconsistencia-header-horas"
        >
          {translate('Horas')}
        </Text>
        <Text
          bold
          flex={3}
          size={tamanhoFonte}
          align="center"
          color={theme.textColor3}
          style={[
            styles.headerText,
            { width: Platform.OS === 'web' ? 65 : isTablet() ? 70 : 60 }
          ]}
          nativeID="inconsistencia-header-justificativa"
        >
          {translate('Justificativa')}
        </Text>
        <Text
          bold
          flex={webDesktop ? 1 : undefined}
          size={tamanhoFonte}
          color={theme.textColor3}
          align="center"
          style={[
            styles.headerText,
            { width: Platform.OS === 'web' || isTablet() ? 50 : 40 }
          ]}
          nativeID="inconsistencia-header-status"
        >
          {translate('Status')}
        </Text>
      </Card.Section>
    );
  }
}

const theme = getTheme();

const styles = StyleSheet.create({
  headerContainer: {
    flexDirection: 'row',
    paddingVertical: 6
  },
  headerText: {
    paddingRight: 5
  }
});

export default InconsistenciaHeader;
